import { blue } from "@mui/material/colors";
import { alpha, useTheme } from "@rentiohq/web-shared-next/dist/themes";
import { EFontWeights } from "@rentiohq/web-shared-next/dist/themes/types";
import { getSuccess200 } from "../../Payments.styles";

// The design marks the selected account in blue (Figma "Blue/500" and
// "Blue/200"), which the dashboard theme does not define; MUI's own color
// palette has exactly these shades.
const SELECTED_RADIO_COLOR = blue[500];
const SELECTED_BORDER_COLOR = blue[200];
const SELECTED_SHADOW = "0 15px 29px rgba(9, 15, 37, 0.04)";

// Values follow "Manage Direct Debit" in the Tenant Dashboard V2 Figma file.
export const ManageDirectDebitsStyles = () => {
  const theme = useTheme();

  const radioIcon = {
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    backgroundColor: theme.palette.grey[200],
  };

  const badge = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "24px",
    py: 0.5,
    borderRadius: "4px",
    fontSize: "10px",
    fontWeight: EFontWeights.Regular,
    lineHeight: "20px",
    color: theme.palette.grey[500],
    whiteSpace: "nowrap",
  };

  return {
    wrapper: {
      borderRadius: "12px",
      py: 2.5,
    },
    content: {
      header: {
        px: "30px",
        pb: "15px",
      },
      title: {
        fontSize: "16px",
        fontWeight: EFontWeights.Medium,
        lineHeight: "24px",
        color: theme.palette.grey[900],
      },
      body: {
        px: "30px",
        pt: "10px",
      },
      helperText: {
        py: 1,
        fontSize: "12px",
        fontWeight: EFontWeights.Regular,
        lineHeight: "20px",
        color: alpha(theme.palette.grey[700], 0.38),
      },
      // Baseline-aligned with the contract link (Stack alignItems); does not
      // shrink when the link wraps on a narrow screen.
      contractLabel: {
        flexShrink: 0,
        fontSize: "14px",
      },
      option: (selected: boolean) => ({
        gap: 2,
        p: 2,
        borderColor: selected ? SELECTED_BORDER_COLOR : theme.palette.grey[200],
        backgroundColor: selected ? theme.palette.common.white : "transparent",
        boxShadow: selected ? SELECTED_SHADOW : "none",
      }),
      radio: {
        p: 0,
      },
      radioIcon,
      radioCheckedIcon: {
        ...radioIcon,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&::after": {
          content: '""',
          width: "10px",
          height: "10px",
          borderRadius: "50%",
          backgroundColor: SELECTED_RADIO_COLOR,
        },
      },
      optionTitle: {
        fontSize: "14px",
        fontWeight: EFontWeights.Medium,
        lineHeight: "20px",
        color: theme.palette.grey[600],
        overflowWrap: "anywhere",
      },
      optionSubtitle: {
        fontSize: "12px",
        fontWeight: EFontWeights.Regular,
        lineHeight: "20px",
        color: theme.palette.grey[500],
      },
      activeBadge: {
        ...badge,
        px: 1,
        backgroundColor: getSuccess200(theme),
      },
      notUsedBadge: {
        ...badge,
        width: "96px",
        px: 0.5,
        backgroundColor: theme.palette.grey[100],
      },
      saveButton: {
        width: "239px",
        maxWidth: "100%",
        px: 2,
        py: 1.5,
        fontSize: "14px",
        fontWeight: EFontWeights.Medium,
        lineHeight: "20px",
      },
      addLink: {
        py: 1,
      },
    },
  };
};
